import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.green,
        // secondary: colors.grey.darken3,
        accent: colors.green.darken2,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.orange.darken1,
        // custom
        highlightRequest: colors.orange.darken3,
        tableHeader: colors.blueGrey.lighten5,
        tableHeaderText: '#000',
        emptyBackground: colors.blueGrey.lighten4,
        mainBackground: colors.white,
        dialogTitleBackground: colors.blueGrey,
        dialogBackground: colors.white
      },
      dark: {
        primary: colors.green,
        // secondary: colors.grey.darken3, //
        accent: colors.green.accent4,
        error: colors.red.accent2, //
        info: colors.blue, //
        success: colors.green, //
        warning: colors.orange.darken1, //
        // custom
        highlightRequest: colors.orange.darken1,
        tableHeader: colors.blueGrey.darken4,
        tableHeaderText: '#eee',
        emptyBackground: colors.black,
        mainBackground: '#1e1e1e',
        dialogTitleBackground: colors.blueGrey.darken4,
        dialogBackground: '#363636'
      }
    }
  }
})
